import {
  CREATE_DEXY_CONVERSATION,
  LIST_DEXY_MESSAGES,
  SET_LOADING,
  UPDATE_DEXY_MESSAGES,
} from "../Actions/dexyActions";

const initialState = {
  conversationId: null,
  messageList: [],
  loading: false,
};

const dexyReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DEXY_CONVERSATION:
      return {
        ...state,
        conversationId: action.conversationId,
      };
    case LIST_DEXY_MESSAGES:
      return {
        ...state,
        messageList: action.messageList,
      };
    case UPDATE_DEXY_MESSAGES:
      return {
        ...state,
        messageList: [action.message, ...state.messageList],
      };


    case SET_LOADING:
      return {
        ...state,
        loading: action.loadingState,
      };
    default:
      return state;
  }
};

export default dexyReducer;
